import { createStore, applyMiddleware } from "redux";
import { syncHistoryWithStore } from "react-router-redux";
import { createBrowserHistory } from "history";
// import { browserHistory } from 'react-router-dom';
import thunk from "redux-thunk";

// import the root reducer
import rootReducer from "./reducers/index";
import appointments from "./data/betterTestData.json";
import menuitems from "./data/menuData.json";
// import { appointmentData } from "./data/Api";

// create an object for the default data
const defaultState = {
  appointments,
  menu: menuitems
};

const store = createStore(rootReducer, applyMiddleware(thunk));

export const history = syncHistoryWithStore(createBrowserHistory(), store);

if (module.hot) {
  module.hot.accept("./reducers/", () => {
    const nextRootReducer = require("./reducers/index").default;
    store.replaceReducer(nextRootReducer);
  });
}

export default store;
